
export const MARKETING_CAMPAIGNS = {
    WEEKLY_NEWSLETTER_ICS: 'initial_weekly_newsletter_ics',
    WEEKLY_NEWSLETTER_MANAGERS: 'initial_weekly_newsletter_managers',
    LEARNER_CHALLENGES_QUARTERLY: 'initial_learner_challenges_quarterly',
    // This campaign was originally created as a monthly campaign, but it's now sent quarterly.
    // We're keeping the original key ('monthly') in the backend for backwards compatibility.
    // In the frontend, we're updating the display name to reflect the correct frequency (quarterly).
    NEWS_AND_UPDATES_QUARTERLY: 'initial_news_and_updates_monthly'
};